import styled, { css } from 'styled-components';

import { Button, Wrapper } from '@trader/components';
import { conditionApply } from '@trader/utils';

interface IPortfolio {
  $isOpenPortfolio?: boolean;
}

export const RightSide = styled(Wrapper)`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ${theme.breakpoints.down('sm')} {
      display: none;
    }
  `};
`;

export const BalanceDetails = styled(Wrapper)<IPortfolio>`
  ${({ theme }) => css`
    border-left: 1px solid ${theme.palette.background.default};
    padding: 0 20px;
    height: 100%;
    width: auto;
    align-items: center;
  `};
`;
export const Logo = styled(Wrapper)`
  ${() => css`
    align-items: center;
    justify-content: center;
  `};
`;
export const Menu = styled(Wrapper)`
  ${({ theme }) => css`
    ${theme.breakpoints.up('sm')} {
      display: none;
    }
  `};
`;

export const Toggle = styled(Button)`
  ${() => css`
    padding: 3px 2px;

    > span {
      display: flex;
      align-items: center;
    }
    svg:first-child {
      margin-right: 8px;
    }
  `};
`;

export const MobileMenu = styled(Wrapper)`
  ${({ theme }) => css`
    ${theme.breakpoints.up('sm')} {
      display: none;
    }
  `};
`;

export const AddFunds = styled(Button)<IPortfolio>`
  ${({ theme, $isOpenPortfolio }) => css`
    color: ${theme.palette.common.white};
    background-color: ${theme.palette.primary.main};
    font-size: 14px;
    font-weight: 700;
    border-radius: 0;
    height: 100%;
    width: 137px;

    &:hover {
      background-color: ${theme.palette.primary.main};
    }

    ${conditionApply(
      [$isOpenPortfolio],
      css`
        background-color: transparent;
        color: ${theme.palette.common.black};
        border-left: 1px solid ${theme.palette.background.default};
        border-right: 1px solid ${theme.palette.background.default};

        &:hover {
          background-color: transparent;
        }
      `
    )}
  `};
`;
